<template>
  <div class="page">
    <v-dialog v-model="loading" persistent width="300">
      <v-card color="secondary" dark class="py-4 px-2">
        <v-progress-linear
          indeterminate
          color="primary"
          class
        ></v-progress-linear>
      </v-card>
    </v-dialog>

    <div v-for="(section, s) in page.sections" :key="s">
      <section-header
        v-if="section.type === 'header'"
        v-model="section.data"
      ></section-header>
      <section-about
        v-if="section.type === 'about'"
        v-model="section.data"
      ></section-about>
      <section-features
        v-if="section.type === 'features'"
        v-model="section.data"
      ></section-features>
      <section-video
        v-if="section.type === 'video'"
        v-model="section.data"
      ></section-video>
      <section-cta
        v-if="section.type === 'cta'"
        v-model="section.data"
      ></section-cta>
      <section-divider
        v-if="section.type === 'divider'"
        v-model="section.data"
      ></section-divider>
      <section-clients
        v-if="section.type === 'clients'"
        v-model="section.data"
      ></section-clients>
    </div>
  </div>
</template>

<script>
import About from "@/components/page/About";
import Features from "@/components/page/Features";
import Video from "@/components/page/Video";
import CTA from "@/components/page/CTA";
import Header from "@/components/page/Header";
import Divider from "@/components/page/Divider";
import Clients from "@/components/page/Clients";
export default {
  name: "Page",
  components: {
    sectionAbout: About,
    sectionFeatures: Features,
    sectionVideo: Video,
    sectionCta: CTA,
    sectionHeader: Header,
    sectionDivider: Divider,
    sectionClients: Clients,
  },
  data() {
    return {
      loading: false,
      page: { sections: [] },
    };
  },
  mounted() {
    this.load();
  },
  methods: {
    async load() {
      this.loading = true;
      try {
        this.page = await this.$api(`/pages/${this.$route.params.slug}`);
      } catch (ex) {
        this.$router.push("/");
      }
      this.loading = false;
    },
  },
};

/*
 We have to pull all service from application data.
 Find service that matches route.params.slug.
Loop through all service.section and display section.

 */
</script>

<style>
.page {
  min-height: 80vh;
}
</style>